export const PARTNER_WHITELIST_STATUS = 'mac/PARTNER_WHITELIST_STATUS';
